<template>
    <div  class="previewInvoice">
        <div v-for="(content) in modules" :key="content.id">
            <component
              :key="content.id"
              :is="content.component"
              :ref="content.refName"
              :refName="content.refName"
              :infoData="previewInfo"
            ></component>
        </div>
    </div>
  </template>
<script>

import { INVOICE_TYPE_LABLE } from '../config';
export default {
    props: {
        previewInfo: {
            type: Object
        },
        invoiceLabel: {
            type: [String, Number]
        }
    },
    data() {
        return {
            modules: [
                {
                    id: 'previewInvoice_CBS',
                    code: 'CBS',
                    name: '货物运输服务发票',
                    refName: 'previewInvoice_CBS',
                    component: () => import('./invoiceTemp_CBS.vue')
                },
                {
                    id: 'previewInvoice_REBLS',
                    code: 'REBLS',
                    name: '不动产经营租赁服务发票',
                    refName: 'previewInvoice_REBLS',
                    component: () => import('./invoiceTemp_REBLS.vue')
                },
                {
                    id: 'previewInvoice_NOLABLE',
                    code: 'NOLABLE',
                    name: '非特异性的标签发票',
                    refName: 'previewInvoice_NOLABLE',
                    component: () => import('./invoiceTemp_NOLABLE.vue')
                }
            ]
        };
    },
    methods: {
        show(invoiceLabel) {
            this.$refs['previewInvoice_' + INVOICE_TYPE_LABLE[`${invoiceLabel || this.invoiceLabel}`]][0].show();
        }
    }
};
</script>
  <style scoped>
  .content {
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    width: 1000px;
  }
  </style>